module.exports = __webpack_public_path__ + "static/media/bowie-knife.e7821736.svg";